import Layout from "../../components/mainPage/Layout";

import image from "../../images/stationMainImage.png";
import manufactureImg from "../../images/manufacture.png"
import { Add } from "shared/components/Add";
import { ImageContainer } from "shared/components/ImageContainer";

export const Page = () => {
  return <Layout >
    <div className="container">
      <div className="article-container">
        <h1 className="mb-4 ">
          Подстанции
        </h1>


        <h1 className="article-title">
          SCADA NPT Expert для автоматизации подстанций: контроль и управление
          энергообъектами
        </h1>
        <p className="article-lead">
          Современные магистральные и распределительные подстанции требуют
          высокого уровня автоматизации для обеспечения надежности,
          безопасности и эффективности работы. SCADA-система (Supervisory
          Control And Data Acquisition) — это ключевое решение для мониторинга
          и управления технологическими процессами в режиме реального времени.
        </p>



        <h2 className="section-title">
          Преимущества SCADA NPT Expert для подстанций:
        </h2>
        <ul className="benefits-list">
          <li className="alert alert-success">
            <span className="icon m-1">✅</span>
            <strong>Централизованный контроль</strong> – удаленное управление
            оборудованием и сбор данных со всех уровней подстанции.
          </li>
          <li className="alert alert-success">
            <span className="icon m-1">✅</span>
            <strong>Автоматизация процессов</strong> – снижение влияния
            человеческого фактора, быстрое реагирование на аварии.
          </li>
          <li className="alert alert-success">
            <span className="icon m-1">✅</span>
            <strong>Мониторинг в реальном времени</strong> – визуализация
            параметров сети (напряжение, ток, мощность), прогнозирование
            нагрузок.
          </li>
          <li className="alert alert-success">
            <span className="icon m-1">✅</span>
            <strong>Анализ и отчетность</strong> – анализ событий,
            формирование отчетов для оптимизации работы.
          </li>
          <li className="alert alert-success">
            <span className="icon m-1">✅</span>
            <strong>Простая интеграция со смежными системами</strong> –
            совместимость с современными системами учета и защиты.
          </li>
        </ul>

        <ImageContainer
          src={image}
          alt={'SCADA система управления подстанцией'}
          caption={'SCADA NPT Expert в работе на современной подстанции'}
        />

        <Add
          text={<><span className="text-accent">Автоматизируйте</span> Ваши подстанции с передовыми SCADA NPT решениями!</>}
          description={'Переход на Industry 4.0 начинается с выбора правильной системы автоматизации'}
          image={manufactureImg}
        />
      </div>
    </div>
  </Layout>

};

export const meta = {
  title: 'Подстанции',
  description: 'SCADA NPT Expert для автоматизации подстанций: контроль и управление энергообъектами'
}